
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface EmptyEntriesStateProps {
  searchTerm: string;
  onClearSearch: () => void;
  onAddFirstEntry: () => void;
}

export const EmptyEntriesState = ({ 
  searchTerm, 
  onClearSearch, 
  onAddFirstEntry 
}: EmptyEntriesStateProps) => {
  return (
    <Card className="p-6 text-center space-y-4">
      {searchTerm ? (
        <>
          <p className="text-gray-600">No entries found matching "{searchTerm}"</p>
          <Button 
            variant="outline" 
            onClick={onClearSearch}
          >
            Clear Search
          </Button>
        </>
      ) : (
        <>
          <p className="text-gray-600">Start your cooking journey by adding your first recipe journal entry!</p>
          <Button 
            className="bg-primary hover:bg-primary/90"
            onClick={onAddFirstEntry}
          >
            Add Your First Entry
          </Button>
        </>
      )}
    </Card>
  );
};
